var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wrapper auth-v1 px-2"},[_c('form-field',{attrs:{"hidden-submit-button":true,"form-id":parseInt(_vm.$route.params.id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }